module.exports = __webpack_public_path__ + "img/DK.0e025345.svg";